export default "__VITE_ASSET__Dlx1UJgF__"